<template>
  <nav class="navbar yamm navbar-default">
    <div class="container">
      <ul class="nav navbar-nav">
        <li><router-link to="/" exact v-bind:class="{ 'home-active': homeActive }">Home</router-link></li>
        <li v-if="loggedIn && !purchasedShortDeck"><router-link to="/equity-calculator">Equity Calculator</router-link></li>
        <li v-if="loggedIn && !purchasedShortDeck"><router-link to="/hit-calculator">Hit Calculator</router-link></li>
        <li v-if="loggedIn && !purchasedShortDeck" class="dropdown yamm-fw">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            All Tools <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li>
              <div class="yamm-content">
                <div class="row">
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/equity-calculator">Equity Calculator</router-link></h3>
                    <router-link to="/equity-calculator"><img src="/static/pages/equity-calculator.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/hit-calculator">Hit Calculator</router-link></h3>
                    <router-link to="/hit-calculator"><img src="/static/pages/hit-calculator.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/equity-matrix">Equity Matrix</router-link></h3>
                    <router-link to="/equity-matrix"><img src="/static/pages/equity-matrix.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/range-constructor">Range Constructor</router-link></h3>
                    <router-link to="/range-constructor"><img src="/static/pages/range-constructor.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/guided-analyses/should-you-bluff">Should You Bluff?</router-link></h3>
                    <router-link to="/guided-analyses/should-you-bluff"><img src="/static/pages/should-you-bluff.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/guided-analyses/should-you-call">Should You Call?</router-link></h3>
                    <router-link to="/guided-analyses/should-you-call"><img src="/static/pages/should-you-call.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/breakeven-percentage-for-bluffing-the-turn">Breakeven Percentage For Bluffing The Turn</router-link></h3>
                    <router-link to="/breakeven-percentage-for-bluffing-the-turn"><img src="/static/pages/breakeven-percentage-for-bluffing-the-turn.png"></router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <h3><router-link to="/three-bet-cbet-explorer">3bet-Cbet Explorer</router-link></h3>
                    <router-link to="/three-bet-cbet-explorer"><img src="/static/pages/three-bet-cbet-explorer.png"></router-link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li v-if="loggedIn && !purchasedShortDeck" class="dropdown mobile">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            All Tools <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li><router-link to="/equity-calculator">Equity Calculator</router-link></li>
            <li><router-link to="/hit-calculator">Hit Calculator</router-link></li>
            <li><router-link to="/equity-matrix">Equity Matrix</router-link></li>
            <li><router-link to="/range-constructor">Range Constructor</router-link></li>
            <li><router-link to="/guided-analyses/should-you-bluff">Should You Bluff?</router-link></li>
            <li><router-link to="/guided-analyses/should-you-call">Should You Call?</router-link></li>
            <li><router-link to="/breakeven-percentage-for-bluffing-the-turn">Breakeven Percentage For Bluffing The Turn</router-link></li>
            <li><router-link to="/three-bet-cbet-explorer">3bet-Cbet Explorer</router-link></li>
          </ul>
        </li>
        <li v-if="purchasedShortDeck" class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            Short Deck <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li><router-link to="/short-deck/equity-calculator">Equity Calculator</router-link></li>
            <li><router-link to="/short-deck/hit-calculator">Hit Calculator</router-link></li>
          </ul>
        </li>
        <li v-if="purchasedShortDeck" class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            Long Deck <span class="caret"></span>
          </a>
          <ul class="dropdown-menu">
            <li><router-link to="/equity-calculator">Equity Calculator</router-link></li>
            <li><router-link to="/hit-calculator">Hit Calculator</router-link></li>
            <li><router-link to="/equity-matrix">Equity Matrix</router-link></li>
            <li><router-link to="/range-constructor">Range Constructor</router-link></li>
            <li><router-link to="/guided-analyses/should-you-bluff">Should You Bluff?</router-link></li>
            <li><router-link to="/guided-analyses/should-you-call">Should You Call?</router-link></li>
            <li><router-link to="/breakeven-percentage-for-bluffing-the-turn">Breakeven Percentage For Bluffing The Turn</router-link></li>
            <li><router-link to="/three-bet-cbet-explorer">3bet-Cbet Explorer</router-link></li>
          </ul>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li v-if="!loggedIn"><router-link to="/pricing">Pricing</router-link></li>
        <li v-if="!loggedIn"><router-link to="/sign-in">Sign In</router-link></li>
        <li v-if="!loggedIn"><router-link to="/register">Register</router-link></li>
        <li v-if="loggedIn && !basicOrPremium"><router-link to="/purchase">Purchase</router-link></li>
        <li v-if="loggedIn" class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown">
            Account <span class="caret"></span>
          </a>
          <ul class="dropdown-menu dropdown-menu-right">
            <li v-if="onBasicPlan"><router-link to="/upgrade">Upgrade</router-link></li>
            <li><router-link to="/settings" exact>Settings</router-link></li>
            <li><router-link to="/account">Account</router-link></li>
            <li><a href="#" v-on:click.prevent="logOut()">Log Out</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'ppt-navbar',
  computed: {
    loggedIn: function () {
      return this.$store.getters['account/loggedIn'];
    },
    onBasicPlan: function () {
      return this.$store.state.account.user.auth.includes('basic');
    },
    basicOrPremium: function () {
      return this.$store.getters['account/basicOrPremium'];
    },
    purchasedShortDeck: function () {
      return this.$store.getters['account/purchasedShortDeck'];
    },
    homeActive: function () {
      return this.$route.name === 'home';
    },
  },
  methods: {
    logOut: function () {
      let self = this;

      self.$http
        .get(`${process.env.BASE_API_URL}/user/logout`)
        .then(function (res) {
          self.$store.dispatch('account/clearUser');
          self.$router.push({ path: '/' });
        })
        .catch(function (err) {
          console.log(err);
        })
      ;
    },
  }
};
</script>

<style lang="scss" scoped>
  nav.navbar.navbar-default {
    margin-bottom: 15px;
    font-size: 12px;
  }

  .mobile {
    display: none;
  }

  .navbar .nav .dropdown-menu .yamm-content a {
    padding: 0;
  }

  .navbar-right .dropdown-menu {
    right: auto;
  }

  img {
    width: 100%;
  }

  .navbar-link {
    text-decoration: underline;
  }

  .router-link-active, .home-active {
    pointer-events: none;
    font-weight: bold;
    position: relative;
    bottom: 2px;

    &:focus {
      color: #777 !important;
    }
  }

  .navbar .nav .dropdown-menu a {
    padding: 10px 20px;
  }

  .glyphicon-new-window {
    color: grey;
  }

  a {
    cursor: pointer;
  }

  // for vertical divider
  .navbar .divider-vertical {
    height: 50px;
    margin: 0 9px;
    border-right: 1px solid #ffffff;
    border-left: 1px solid #f2f2f2;
  }

  .navbar-inverse .divider-vertical {
    border-right-color: #222222;
    border-left-color: #111111;
  }

  .dropdown-menu-right {
    right: 0 !important;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    .col-md-3.col-sm-4 {
      height: 200px;
    }
  }

  @media (max-width: 767px) {
    .nav > .divider-vertical {
      display: none !important;
    }

    .mobile {
      display: block;
    }

    .yamm-fw {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue